import * as actionTypes from "../../constants/actionTypes";
import * as handlers from "../../constants/handlers";
import * as license from "../../constants/license";
import * as methods from "../../constants/methods";
import * as modules from "../../constants/modules";
import * as resultCodes from "../../constants/resultCodes";
import * as matchingActions from "../../actions/matchingActions";
import * as messageHelper from "../../helpers/messageHelper";
import * as modelHelper from "../../helpers/modelHelper";
import * as responseHelper from "../../helpers/responseHelper";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.GET_LICENSE_STATUS:
            if (!responseHelper.isGetLicenseStatusFormatValid(response)) {
                return [
                    messageHelper.getInvalidFormatMessage(response),
                    {
                        type: actionTypes.SOFTWARE_INITIALIZED
                    }
                ];
            }

            if (
                response.data.status > 0 &&
                Array.isArray(response.data.modules) &&
                Array.isArray(response.data.modules2) &&
                (response.data.product === license.PRODUCT_ONE ||
                    response.data.product === license.PRODUCT_PRICING ||
                    response.data.product === license.PRODUCT_ENTRY ||
                    response.data.product === license.PRODUCT_DISPENSING ||
                    response.data.product === license.PRODUCT_DISPENSING_MANUAL ||
                    response.data.product === license.PRODUCT_PLUS)
            ) {
                let licenseStatusActions = [
                    {
                        type: actionTypes.SERVER_IS_LICENSED,
                        payload: {
                            modules: response.data.modules,
                            product: response.data.product,
                            status: response.data.status,
                            expiration: response.data.expiration,
                            licenseLastUpdate: response.data.generated,
                            remaining: response.data.remaining,
                            licenseModules: modelHelper.mapLicenseModules(response.data.modules2)
                        }
                    }
                ];

                if (response.data.showExpirationWarning && !state.module.setupSoftware) {
                    licenseStatusActions.push({type: actionTypes.SOFTWARE_INITIALIZED});
                } else {
                    licenseStatusActions.push({type: actionTypes.SOFTWARE_START_INITIALIZATION});
                }

                return licenseStatusActions;
            }

            let licenseErrorActions = [
                {
                    type: actionTypes.LICENSE_SAVE_ERROR,
                    payload: {
                        code: response.data.error === undefined ? -1 : response.data.error.code
                    }
                },
                {
                    type: actionTypes.SOFTWARE_INITIALIZED
                }
            ];

            if (!state.module.setupSoftware) {
                licenseErrorActions.push(messageHelper.getLicenseErrorMessage(response));
            }

            return licenseErrorActions;
        case handlers.GET_LICENSE_STATUS_COMPACT:
            if (!responseHelper.isGetLicenseStatusFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            if (
                response.data.status > 0 &&
                Array.isArray(response.data.modules) &&
                Array.isArray(response.data.modules2) &&
                (response.data.product === license.PRODUCT_ONE ||
                    response.data.product === license.PRODUCT_PRICING ||
                    response.data.product === license.PRODUCT_ENTRY ||
                    response.data.product === license.PRODUCT_DISPENSING ||
                    response.data.product === license.PRODUCT_DISPENSING_MANUAL ||
                    response.data.product === license.PRODUCT_PLUS)
            ) {
                let licenseModules = modelHelper.mapLicenseModules(response.data.modules2);

                let licenseStatusActions = [
                    {
                        type: actionTypes.SERVER_IS_LICENSED_COMPACT,
                        payload: {
                            modules: response.data.modules,
                            product: response.data.product,
                            status: response.data.status,
                            expiration: response.data.expiration,
                            licenseLastUpdate: response.data.generated,
                            remaining: response.data.remaining,
                            licenseModules: licenseModules
                        }
                    },
                    messageHelper.getInfoMessageAction("flashMessage.licenseUpdated")
                ];

                if (
                    licenseModules.some((module) => module.code === modules.MODULE_PRODUCT_GROUPS) ||
                    state.module.modules.some((module) => module.code === modules.MODULE_PRODUCT_GROUPS)
                ) {
                    licenseStatusActions.push({
                        type: actionTypes.SERVER_REQUEST,
                        payload: {
                            type: methods.METHOD_GET_ALL_PRODUCTS,
                            params: {
                                tree: true
                            }
                        },
                        method: handlers.RELOAD_GLOBAL_ALL_PRODUCTS,
                        tabId: 0
                    });
                    licenseStatusActions.push({
                        type: actionTypes.SERVER_REQUEST,
                        payload: {
                            type: methods.METHOD_GET_ALL_PRODUCTS,
                            params: {
                                tree: false
                            }
                        },
                        method: handlers.RELOAD_GLOBAL_ALL_PRODUCTS_SIMPLE,
                        tabId: 0
                    });

                    if (state.global.matchingInitialized && state.global.matchingAvailable) {
                        licenseStatusActions.push(matchingActions.getMatchingProducts());
                    }
                }

                return licenseStatusActions;
            }

            return [messageHelper.getLicenseErrorMessage(response)];

        case handlers.GET_LICENSE_INFO:
            if (!responseHelper.isGetLicensingInfoFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.LICENSE_SAVE_INFO,
                    payload: {
                        data: response.data
                    }
                },
                {
                    type: actionTypes.SAVE_COMPUTER_ID,
                    payload: {
                        data: response.data ? response.data : null
                    }
                }
            ];
        case handlers.ONLINE_ACTIVATION_AVAILABLE_FOR_LICENSE_WIZARD:
            if (response.result !== resultCodes.RESULT_OK) {
                return [
                    messageHelper.getInvalidFormatMessage(response),
                    {
                        type: actionTypes.SOFTWARE_INITIALIZED
                    }
                ];
            }

            if (!response.data) {
                return [
                    {
                        type: actionTypes.SERVER_REQUEST,
                        payload: {
                            type: methods.METHOD_GET_LICENSE_REQUEST
                        },
                        method: handlers.GET_LICENSE_REQUEST,
                        tabId: 0
                    },
                    {
                        type: actionTypes.LICENSE_SAVE_ONLINE_ACTIVATION_FOR_WIZARD,
                        payload: {
                            available: response.data
                        }
                    },
                    {
                        type: actionTypes.SOFTWARE_INITIALIZED
                    }
                ];
            }

            return [
                {
                    type: actionTypes.LICENSE_SAVE_ONLINE_ACTIVATION_FOR_WIZARD,
                    payload: {
                        available: response.data
                    }
                },
                {
                    type: actionTypes.SOFTWARE_INITIALIZED
                }
            ];
        case handlers.ONLINE_LICENSE_ACTIVATION_AVAILABLE:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.LICENSE_SAVE_ONLINE_ACTIVATION,
                    payload: {
                        available: response.data
                    }
                }
            ];
        case handlers.ONLINE_LICENSE_UPDATE:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            if (response.data === license.LICENSE_UPDATE_RESULT_LICENSE_UPDATED) {
                return [
                    {
                        type: actionTypes.SERVER_REQUEST,
                        payload: {
                            type: methods.METHOD_GET_LICENSE_STATUS
                        },
                        method: handlers.GET_LICENSE_STATUS_COMPACT,
                        tabId: 0
                    }
                ];
            }

            if (response.data === license.LICENSE_UPDATE_RESULT_LICENSE_VALID_NO_UPDATE_NEEDED) {
                return [messageHelper.getInfoMessageAction("flashMessage.licenseUpToDate")];
            }

            return [messageHelper.getErrorMessageAction("flashMessage.licenseUpdateUnsuccessful")];
        case handlers.GET_LICENSE_REQUEST:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.LICENSE_SAVE_REQUEST,
                    payload: {
                        request: response.data !== undefined && typeof response.data === "string" ? response.data : null
                    }
                }
            ];
        case handlers.GET_AVAILABLE_LICENSE_PRODUCTS_ORDERED:
            if (!responseHelper.isGetLicenseProductsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.LICENSE_SAVE_PRODUCT_LIST_ORDER,
                    payload: {
                        productListOrder: response.data
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_AVAILABLE_LICENSE_PRODUCTS
                    },
                    method: handlers.GET_AVAILABLE_LICENSE_PRODUCTS,
                    tabId: 0
                }
            ];
        case handlers.GET_AVAILABLE_LICENSE_PRODUCTS:
            if (!responseHelper.isGetLicenseProductsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.LICENSE_SAVE_PRODUCT_LIST,
                    payload: {
                        productList: response.data
                    }
                },
                {
                    type: actionTypes.LICENSE_GET_ONLINE_COUNTS
                }
            ];
        case handlers.ONLINE_LICENSE_COUNTS:
            if (response.result !== resultCodes.RESULT_OK) {
                return [
                    messageHelper.getInvalidFormatMessage(response),
                    {
                        type: actionTypes.LICENSE_DELETE_IDENTIFICATION
                    }
                ];
            }

            return [
                {
                    type: actionTypes.LICENSE_SET_PROCESS_STEP,
                    payload: {
                        step: 2
                    }
                },
                {
                    type: actionTypes.LICENSE_SAVE_ONLINE_COUNTS,
                    payload: {
                        counts: response.data
                    }
                }
            ];
        case handlers.ONLINE_LICENSE_ACTIVATE:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_LICENSE_STATUS
                    },
                    method: handlers.GET_LICENSE_STATUS,
                    tabId: 0
                }
            ];
        case handlers.CREATE_LICENSE_REQUEST:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_LICENSE_REQUEST
                    },
                    method: handlers.GET_LICENSE_REQUEST,
                    tabId: 0
                }
            ];
        case handlers.REMOVE_LICENSE_REQUEST:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.LICENSE_SAVE_REQUEST,
                    payload: {
                        request: null
                    }
                }
            ];
        case handlers.INSTALL_LICENSE:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_LICENSE_STATUS
                    },
                    method: handlers.GET_LICENSE_STATUS,
                    tabId: 0
                }
            ];
        case handlers.GET_REGISTRATION_DATA:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_REGISTRATION_DATA,
                    payload: {
                        registrationData: response.data
                    }
                }
            ];
        case handlers.SET_REGISTRATION_DATA:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_REGISTRATION_DATA
                    },
                    method: handlers.GET_REGISTRATION_DATA,
                    tabId: 0
                },
                {
                    type: actionTypes.MENU_SET_MENU_ITEM,
                    payload: {
                        item: null,
                        submenuItem: null
                    }
                }
            ];
        case handlers.GET_POS_INFO:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_POS_FORM_INFO,
                    payload: {
                        posInfo: response.data.info
                    }
                },
                {
                    type: actionTypes.MENU_SET_MENU_ITEM,
                    payload: {
                        item: null,
                        submenuItem: null
                    }
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
